import { ReactNode, useState } from "react";
import FacetMobile from "components/coveo-headless/components/FacetMobile";
import { setBodyPositionFixed } from "utils/dom";
import { BreadcrumbManager, Facet } from "@coveo/headless";
import { CoveoHeadlessFacetName, PageType } from "../types/coveo-headless-types";
import { ImageArrow } from "components/utility/images";

type FacetGroupMobileProps = {
	children: ReactNode;
	breadcrumbs: BreadcrumbManager;
	facets: Facet[];
	facetQuantifier?: string;
	fields: CoveoHeadlessFacetName[];
	mobileFacetGroupLabel: string;
	mobileFilterCount: number;
	mobileSelectedFacets: Record<string, string[]>;
	toggleMobileFacetList: boolean;
	pageType: string;
	setToggleMobileFacetGroup: React.Dispatch<React.SetStateAction<boolean>>;
	setToggleMobileFacetList: React.Dispatch<React.SetStateAction<boolean>>;
	selectedDropdown: number;
	setSelectedDropdown?: (selectedDropdown: number) => void;
};

const FacetGroupMobile = ({
	children,
	breadcrumbs,
	facets,
	facetQuantifier,
	fields,
	mobileFacetGroupLabel,
	mobileFilterCount,
	mobileSelectedFacets,
	pageType,
	selectedDropdown,
	toggleMobileFacetList,
	setToggleMobileFacetGroup,
	setToggleMobileFacetList,
	setSelectedDropdown
}: FacetGroupMobileProps) => {
	const [selectedFacet, setSelectedFacet] = useState(0);

	const handleClick = (index: number) => {
		setToggleMobileFacetList(!toggleMobileFacetList);
		setSelectedFacet(index);
		setSelectedDropdown?.(index);
	};

	return (
		<>
			<div className="coveo-headless-mobile-facet-group-title">
				<div
					className={`coveo-headless-mobile-facet-group-label ${
						toggleMobileFacetList ? "coveo-headless-mobile-facet-group-label-open" : ""
					}`}
					role="button"
					tabIndex={0}
					onClick={() => {
						setToggleMobileFacetList(false);
						setSelectedDropdown?.(-1);
					}}
					onKeyDown={() => {
						setToggleMobileFacetList(false);
						setSelectedDropdown?.(-1);
					}}
				>
					{toggleMobileFacetList ? fields[selectedFacet].name : mobileFacetGroupLabel}
				</div>
				<button
					aria-label="close"
					className="button-icon button-icon-black button-close coveo-headless-mobile-facet-group-reset-clear-btn"
					disabled={mobileFilterCount === 0}
					onClick={() => {
						toggleMobileFacetList ? facets[selectedFacet].deselectAll() : breadcrumbs.deselectAll();
					}}
				>
					{toggleMobileFacetList ? "Clear All" : "Reset"}
				</button>
			</div>
			{facets
				? facets.map((_facet, index) => {
						const facetName = fields[index].facetField;
						let facetList = "";
						let facetListCount = 0;
						if (fields[index].hide) {
							return null;
						} else if (mobileSelectedFacets.hasOwnProperty(facetName)) {
							facetList = mobileSelectedFacets[facetName].join(", ");
							facetListCount = mobileSelectedFacets[facetName].length;
						}
						return (
							<div
								key={`${fields[index].facetField}-mobile`}
								aria-label={fields[index].facetField}
								aria-expanded={index === selectedDropdown}
								className={`coveo-headless-mobile-tab-container ${
									toggleMobileFacetList ? "hide" : ""
								}`}
								data-order="0"
								data-tag={fields[index].facetField}
								role="button"
								tabIndex={0}
								onClick={() => handleClick(index)}
								onKeyDown={() => handleClick(index)}
							>
								<div
									role="heading"
									aria-level={2}
									aria-label={`${fields[index].name} facet`}
									className="coveo-headless-mobile-tab-title"
								>
									{`${fields[index].name} ${facetListCount > 0 ? `(${facetListCount})` : ""}`}
								</div>
								<span className="coveo-headless-mobile-filter-list">
									{facetList === "" ? `${facetQuantifier} ${fields[index].name}` : facetList}
									<ImageArrow />
								</span>
							</div>
						);
					})
				: null}
			<ul className={`coveo-headless-mobile-facet-list ${toggleMobileFacetList ? "open" : ""}`}>
				<FacetMobile
					showCount={pageType === PageType.Search}
					sortItems={pageType !== PageType.Search}
					facet={facets[selectedFacet]}
					facetGroup={fields[selectedFacet].name}
				/>
			</ul>
			<div
				className={`coveo-headless-mobile-filter-show-results-button ${
					toggleMobileFacetList ? "hide" : ""
				}`}
				role="button"
				tabIndex={0}
				onClick={() => {
					setBodyPositionFixed();
					setToggleMobileFacetGroup(false);
				}}
				onKeyDown={() => {
					setBodyPositionFixed();
					setToggleMobileFacetGroup(false);
				}}
			>
				{children}
			</div>
		</>
	);
};
export default FacetGroupMobile;
